'use es6';

import { INITIALIZE_AUTH, HUB_FETCH_RECEIVED, INITIALIZE_ADMIN_AUTH } from '../actions/ActionTypes';
export const initialState = {
  gates: [],
  portal: {},
  user: {
    scopes: []
  }
};

const auth = (state = initialState, action) => {
  switch (action.type) {
    case INITIALIZE_AUTH:
      return {
        user: action.user,
        gates: action.gates,
        portal: action.portal
      };

    case INITIALIZE_ADMIN_AUTH:
      return Object.assign({}, state, {
        user: action.user
      });

    case HUB_FETCH_RECEIVED:
      {
        const portal = Object.assign({}, state.portal, {}, {
          scopes: action.payload
        });
        return Object.assign({}, state, {}, {
          portal
        });
      }

    default:
      return state;
  }
};

export default auth;